import VModal from '@/vuetify_custom/v-modal_v1'
import {VBtn, VIcon} from 'vuetify/lib'
import VForm from '@/vuetify_custom/v-form'
import {postCustomerSalaryAdjustApplyBatchApplySaveApi} from '@/views/fin/salaryadministration/service.js'
import { getsafe } from '@/libs/util.js'
import styles from '@/views/fin/salaryadministration/index.module.less'
export default {
    data() {
        return {
            show: false,
            params: {
                team_id: null,
                file: null,
            }
        }
    },
    computed: {
        form_fields() {
            return [
                {
                    label: '团队',
                    type: 'team_select',
                    key: 'team_id',
                    required: true,
                    cols: 8,
                    rules:[val => !!val || '必选']
                },
            ]
        }
    },
    methods:{
        edit() {
            this.show = true
            this.destryedDom()
            this.params = {
                team_id: null,
                file: null,
            }
        },
        destryedDom() {
            this.params.file = null
            if (!this.el) {
                return 
            }
            this.el.removeEventListener && this.el.removeEventListener('change', this.uploadFile)
            const childrenInputs = this.$refs.contain.childNodes || []
            for (let i = 0, len = childrenInputs.length; i < len; i++) {
              if (childrenInputs[i] instanceof HTMLElement) {
                this.$refs.contain.removeChild(childrenInputs[i])      
              }
            }
            this.el = null
        },
        upload() {
            this.el = document.createElement('input')
            this.el.setAttribute('type', 'file')
            this.$refs.contain.appendChild(this.el)
            this.el.click()
            this.el.addEventListener('change', this.uploadToState)
        },
        uploadToState() {
            const files = getsafe(this.el, 'files') || []
            this.params.file = files[0]
            const file = this.params.file
            if (!file) {
                return 
            }
            const format = ['xlsx', 'csv']
            const arr = (format || []).map(item => new RegExp(item + '$'))
            if (arr.some(item => (item.test(file.type) || item.test(file.name)))) {
                if (file.name.indexOf('%') > -1) {
                    this.$Modal.error({
                      title: '提示',
                      content: '文件名不能包含百分号%'
                    });
                    this.destryedDom()
                    return
                  }
            } else {
                this.$Modal.error({
                    title: '提示',
                    content: `请上传${format.join('、')}格式文件`
                  })
                  this.destryedDom()
            }
        },
          uploadFile() {
            if (!this.$refs.form.validate()) {
                return      
            }
            const file = this.params.file
            if (!file) {
                this.$Message.warning('请添加文件！')
                return 
            }
            const formData = new FormData();
            formData.append('file', file)
            formData.append('team_id', this.params.team_id)
          
            
            // placing_ads_record_import
            this.uploading = true
            postCustomerSalaryAdjustApplyBatchApplySaveApi(formData).then(res => {
              if (res instanceof Array) {
                this.$vModal.error({
                    title:'错误',
                    render: () => <div>
                        {res.map(item => <p>{item}</p>)}
                    </div>
                })
              } else {
                this.$Message.success('数据上传成功！')
              }
              this.destryedDom()
              this.show = false
            //  this.$Message.success('数据上传成功！')
              this.$emit('success')
            }).finally(() => {
                this.$emit('finally');
                this.uploading = false
            })
            // http.post_upload(upload_url, { formData }).then(() => {
            
            //   this.destryedDom()
            //   this.show = false
            //   this.$Message.success('数据上传成功！')
            //   this.$emit('success')
            // }).finally(() => {
            //   this.$emit('finally');
            //   this.uploading = false
            // })
          },
    },
    render() {
        return <VModal
                v-model={this.show}
                title="数据导入"
                width={500}
                loading={this.uploading}
                on={{
                    ok: () => {
                       this.uploadFile()
                        
                    },
                }}
        >
            <div >
             <VForm 
                    ref="form" 
                    fields={this.form_fields} 
                    v-model={this.params}
                />
                <VBtn color="primary" small on={{
                    click:() => this.upload()
                }}>添加文件</VBtn>
                {this.params.file && <p class={styles['p-m']}>{this.params.file.name}<span on={{click:() => this.destryedDom()}}> <VIcon color="red">mdi-delete-circle-outline</VIcon></span></p>}
                <div ref="contain" style="display: none"></div>
            </div>
        </VModal>
    }
}